import type { ReactNode } from "react";

interface StatusPanelProps {
  title: string;
  children: ReactNode;
}

/**
 * `/status` is one of this story's own reachable screens (review round 1
 * scope clarification — see the Validation Contract's Amendments), so it
 * follows the same rules as the nine destinations: real tokens, no shadow
 * outside the three DESIGN.md names (dialog, search overlay, phone sheet —
 * a status card is none of them), `{typography.title}` for the heading.
 */
export function StatusPanel({ title, children }: StatusPanelProps) {
  return (
    <section className="mx-auto mt-24 w-full max-w-md rounded-lg border border-border-hairline bg-canvas p-6">
      <h1 className="text-title font-semibold tracking-title text-ink">{title}</h1>
      <div className="mt-4 text-body text-ink">{children}</div>
    </section>
  );
}
